import { BulkTagArgs, ClusterGridParams } from 'src/context/api/tags/api';

type BulkTagInput = {
  fullResult: boolean;
  queryParams: ClusterGridParams;
  addTags: { label: string }[];
  searchTerms: { id?: string; label: string }[];
};

/**
 * Arguments of the bulk "add clusters" call.
 * "Select all" re-runs the grid query server-side, so it carries exactly what the
 * grid shows: the tab's region and the header's cluster filter. It used to send the
 * whole country list, clustering every country's terms from a single-country tab.
 */
export const buildBulkTagArgs = ({ fullResult, queryParams, addTags, searchTerms }: BulkTagInput): BulkTagArgs => {
  const { workspaceId, module, region } = queryParams;
  if (!fullResult) return { workspaceId, module, region, addTags, searchTerms };
  const { start, end, keywords, devices, platforms, tags, filterModel } = queryParams;
  return { workspaceId, module, region, addTags, start, end, keywords, devices, platforms, tags, filterModel };
};
